// Canonical MIME-type vocabularies for the whole monorepo.
//
// This file is intentionally DEPENDENCY-FREE so it can be deep-imported via
// `@sc/document-processing/mime-types` from the frontend (and any other consumer)
// without pulling in the node-only PDF/DOCX parsers that the main
// `@sc/document-processing` entry point depends on.

// Raw document types `extractText()` can turn into text. Note: `text/csv` is
// intentionally excluded here — it is only handled by the hosted Drive/Dropbox
// processors (decoded directly), not by raw-file extraction. This is the list
// the client-api uses to validate raw uploads.
export const extractableDocumentMimeTypes: readonly string[] = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/rtf',
  'text/rtf',
  'text/html',
  'text/plain',
  'text/markdown',
  'text/x-markdown',
];

// Raw types accepted from hosted integrations (Google Drive / Dropbox) and the
// Drive picker: everything extractable, plus `text/csv` which the integration
// processors decode directly.
export const indexableRawMimeTypes: readonly string[] = [
  ...extractableDocumentMimeTypes,
  'text/csv',
];

// Google-native types mapped to the format they are exported as for indexing.
export const googleDriveExportMimeTypes: Record<string, string> = {
  'application/vnd.google-apps.document': 'text/plain',
  'application/vnd.google-apps.spreadsheet': 'text/csv',
  'application/vnd.google-apps.presentation': 'text/plain',
  'application/vnd.google-apps.drawing': 'application/pdf',
};

// The Google-native types themselves (keys of the export map above).
export const googleNativeMimeTypes: readonly string[] = Object.keys(
  googleDriveExportMimeTypes
);

// Dropbox file extension → MIME type used for S3 + extractText in the Pinecone
// path. Covers `indexableRawMimeTypes`.
export const dropboxExtensionToMimeType: Record<string, string> = {
  '.pdf': 'application/pdf',
  '.docx':
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.txt': 'text/plain',
  '.md': 'text/markdown',
  '.markdown': 'text/markdown',
  '.html': 'text/html',
  '.htm': 'text/html',
  '.rtf': 'application/rtf',
  '.csv': 'text/csv',
};
